<div
  (scrolled)="onScroll()"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="10"
  [scrollWindow]="false"
  class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
  infiniteScroll
>
  <table
    (matSortChange)="sortData($event)"
    [class.hidden]="loading && isFirstPage"
    [dataSource]="dataSource"
    mat-table
    matSort
  >
    <!--      NAME-->
    <ng-container
      matColumnDef="name"
      sticky
    >
      <th
        *matHeaderCellDef
        id="name"
        mat-header-cell
        mat-sort-header
      >
        Name
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] md:w-[20rem] md:min-w-[20rem]"
          mat-cell>
          <span
            (click)="eachRow.status.key > userStatusMap.inProcess ?
             openUserDetails(eachRow) : {}"
            [class.clickable]="eachRow.status.key > userStatusMap.inProcess"
          >
            {{ eachRow.firstName }} {{ eachRow.lastName }}
          </span>
      </td>
    </ng-container>
    <!--      PRONOUNS-->
    <ng-container
      matColumnDef="preferredPronouns"
    >
      <th
        *matHeaderCellDef
        id="preferredPronouns"
        mat-header-cell
        mat-sort-header
      >
        Preference
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ eachRow.preferredPronouns?.value }}
      </td>
    </ng-container>
    <!--      ROLE-->
    <ng-container
      matColumnDef="role"
    >
      <th
        *matHeaderCellDef
        id="role"
        mat-header-cell
        mat-sort-header
      >
        Role
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ typeMap[eachRow.role?.key] }}
      </td>
    </ng-container>
    <!--      STATUS-->
    <ng-container
      matColumnDef="status"
    >
      <th
        *matHeaderCellDef
        id="status"
        mat-header-cell
        mat-sort-header
      >
        Status
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <div class="flex flex-row gap-[1rem] td-cell items-center">
          <div
            [ngStyle]="{'background-color':
            userStatusColors[eachRow.status?.key]}"
            class="indicator"
          >
          </div>
          <div class="status-text text">
            {{ eachRow.status?.value }}
          </div>
        </div>
      </td>
    </ng-container>
    <!--      Phone Number-->
    <ng-container
      matColumnDef="phoneNumber"
    >
      <th
        *matHeaderCellDef
        id="phoneNumber"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          Phone Number
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.phoneNumber }}
      </td>
    </ng-container>
    <!--      Email-->
    <ng-container
      matColumnDef="email"
    >
      <th
        *matHeaderCellDef
        id="email"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          Email ID
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.emailId }}
      </td>
    </ng-container>
    <!--      GENDER-->
    <ng-container
      matColumnDef="gender"
    >
      <th
        *matHeaderCellDef
        id="gender"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Gender
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ eachRow.gender?.value }}
      </td>
    </ng-container>
    <!--      AGE AT START-->
    <ng-container
      matColumnDef="ageAtStart"
    >
      <th
        *matHeaderCellDef
        id="ageAtStart"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Age at Start
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[12rem] min-w-[12rem]"
          mat-cell>
        {{ eachRow.ageAtStart }}
      </td>
    </ng-container>
    <!--      Most Recent Attended Sessions Group-->
    <ng-container
      matColumnDef="mostRecentAttendedSessionsGroup"
    >
      <th
        *matHeaderCellDef
        id="mostRecentAttendedSessionsGroup"
        mat-header-cell
        mat-sort-header
      >
        Group Name
      </th>
      <td
        (click)="eachRow.latestGroupName ? groupNameClick(eachRow): ''"
        *matCellDef="let eachRow"
        class="w-[20rem] min-w-[20rem]"
        mat-cell
      >
          <span
            [class.clickable]="eachRow?.latestGroupName"
          >
            {{ eachRow.latestGroupName }}
          </span>
      </td>
    </ng-container>
    <!--    PGS-->
    <ng-container matColumnDef="participantsGroupStatus">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Participant Group Status
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <div class="flex flex-row gap-[1rem] td-cell items-center">
          <div
            [ngStyle]="{'background-color':
            participantGroupStatusColors[eachRow?.participantsGroupStatus?.key]}"
            class="indicator"
          >
          </div>
          <div class="status-text text">
            {{ eachRow?.participantsGroupStatus?.value }}
          </div>
        </div>
      </td>
    </ng-container>
    <!--      Most Recent Attended Session-->
    <ng-container
      matColumnDef="mostRecentAttendedSession"
    >
      <th
        *matHeaderCellDef
        id="mostRecentAttendedSession"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px] text-center"
        >
          Most Recent Session Attended
        </div>
      </th>
      <td (click)="sessionNameClick(eachRow)"
          *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] clickable"
          mat-cell>
        {{
          eachRow.mostRecentAttendedSession ? 'Session ' +
            eachRow.mostRecentAttendedSession : ''
        }}
      </td>
    </ng-container>
    <!--      Total Attendance-->
    <ng-container
      matColumnDef="totalSessionsConducted"
    >
      <th
        *matHeaderCellDef
        id="totalSessionsConducted"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Total Attendance
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <ng-container *ngIf="eachRow.totalSessionsConducted; else noData">
          {{ eachRow.totalAttendedSessions }}
          / {{ eachRow.totalSessionsConducted }}
        </ng-container>
        <ng-template #noData>

        </ng-template>
      </td>
    </ng-container>
    <!--      Ethnicity-->
    <ng-container
      matColumnDef="ethnicity"
    >
      <th
        *matHeaderCellDef
        id="ethnicity"
        mat-header-cell
        mat-sort-header
      >
        <div>
          Ethnicity
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.ethnicity }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Preferred Language-->
    <ng-container
      matColumnDef="preferredLanguage"
    >
      <th
        *matHeaderCellDef
        id="preferredLanguage"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Preferred Language
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.preferredLanguage }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Race-->
    <ng-container
      matColumnDef="race"
    >
      <th
        *matHeaderCellDef
        id="race"
        mat-header-cell
        mat-sort-header
      >
        <div>
          Race
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.race }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Govt Assist-->
    <ng-container
      matColumnDef="govtAssist"
    >
      <th
        *matHeaderCellDef
        id="govtAssist"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Govt Assistance
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.govtAssist }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Snap-->
    <ng-container
      matColumnDef="snap"
    >
      <th
        *matHeaderCellDef
        id="snap"
        mat-header-cell
        mat-sort-header
      >
        <div>
          SNAP
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.snap }}
        </ng-container>
      </td>
    </ng-container>
    <!--      schoolLunchProgram-->
    <ng-container
      matColumnDef="schoolLunchProgram"
    >
      <th
        *matHeaderCellDef
        id="schoolLunchProgram"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          School Lunch Program
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.schoolLunchProgram }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Food Insecurity-->
    <ng-container
      matColumnDef="foodInsecurity"
    >
      <th
        *matHeaderCellDef
        id="foodInsecurity"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Food Insecurity
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[16rem] min-w-[16rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.foodInsecurity }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Housing Insecurity-->
    <ng-container
      matColumnDef="housingInsecurity"
    >
      <th
        *matHeaderCellDef
        id="housingInsecurity"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Housing Insecurity
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[16rem] min-w-[16rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.housingInsecurity }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Financial Strain-->
    <ng-container
      matColumnDef="financialStrain"
    >
      <th
        *matHeaderCellDef
        id="financialStrain"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Financial Strain
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[16rem] min-w-[16rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.financialStrain }}
        </ng-container>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div
    *ngIf="!loading && !dataSource.data?.length"
    class="no-data flex flex-col justify-center items-center"
  >
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
